/* =============================================================================
   FTB BUNDLE BUILDER
   ─────────────────────────────────────────────────────────────────────────────
   CART: Items are added to the real Shopify cart via /cart/add.js (AJAX).
         Products appear in the cart and checkout normally.

   DISCOUNT: The displayed "Kit price" is visual only. No real discount is applied
             at cart/checkout UNLESS the merchant has set a discount code in the
             section settings OR has an active Shopify Automatic Discount that
             covers these products. If a discount_code is set, it is stored in
             sessionStorage and applied when the user clicks checkout (redirects
             to /checkout?discount=CODE). No redirect before checkout.

   Requires: window.FTBCart (set by ftb-cart.js, loaded before this file)
   ============================================================================= */

(function () {
  'use strict';

  var REQUIRED = 3;
  var slots = {};

  var sectionEl    = document.getElementById('ftb-bundle-section');
  var slotsGrid    = document.getElementById('ftb-bundle-slots');
  var picker       = document.getElementById('ftb-bundle-picker');
  var pickerClose  = document.getElementById('ftb-picker-close');
  var pickerGrid   = document.getElementById('ftb-picker-grid');
  var showMoreBtn  = document.getElementById('ftb-picker-show-more');
  var bundleCta    = document.getElementById('ftb-bundle-cta');
  var statusEl     = document.getElementById('ftb-bundle-status');
  var pricingEl    = document.getElementById('ftb-bundle-pricing');
  var fullPriceEl  = document.getElementById('ftb-bundle-full-price');
  var kitPriceEl   = document.getElementById('ftb-bundle-kit-price');
  var savingEl     = document.getElementById('ftb-bundle-saving');

  if (!slotsGrid) return;

  var discountPct         = sectionEl ? (parseInt(sectionEl.dataset.discount, 10) || 20) : 20;
  var discountCode        = sectionEl ? (sectionEl.dataset.discountCode || '') : '';
  var showVisualDiscount  = sectionEl ? sectionEl.dataset.showVisualDiscount === 'true' : false;
  var activeSlot   = null;
  var pickerExpanded = false;

  /* Tier thresholds + labels — read from section data attributes */
  var t1       = sectionEl ? (parseInt(sectionEl.dataset.t1, 10) || 3) : 3;
  var t2       = sectionEl ? (parseInt(sectionEl.dataset.t2, 10) || 5) : 5;
  var t3       = sectionEl ? (parseInt(sectionEl.dataset.t3, 10) || 7) : 7;
  var t1Label  = sectionEl ? (sectionEl.dataset.t1Label || 'Free delivery')    : 'Free delivery';
  var t2Label  = sectionEl ? (sectionEl.dataset.t2Label || 'Kit discount')     : 'Kit discount';
  var t3Label  = sectionEl ? (sectionEl.dataset.t3Label || 'Maximum savings')  : 'Maximum savings';
  var maxProducts = t3; /* progress bar and unlock logic cap at tier 3 */

  /* Gift variant IDs — set in theme editor under Bundle rewards */
  var gift1VariantId = sectionEl ? (sectionEl.dataset.gift1Variant || '57368758976894') : '57368758976894';
  var gift2VariantId = sectionEl ? (sectionEl.dataset.gift2Variant || '57368654479742') : '57368654479742';
  var ctaText        = sectionEl ? (sectionEl.dataset.ctaText || 'Add Kit To Basket').toUpperCase() : 'ADD KIT TO BASKET';

  var progressFillEl  = document.getElementById('ftb-bundle-progress-fill');
  var progressCountEl = document.getElementById('ftb-bundle-progress-count');
  var unlockMsgEl     = document.getElementById('ftb-bundle-unlock-msg');
  var kitTotalEl      = document.getElementById('ftb-bundle-kit-total');
  var kitTotalPriceEl = document.getElementById('ftb-bundle-kit-total-price');
  var tier1El         = document.getElementById('ftb-tier-1');
  var tier2El         = document.getElementById('ftb-tier-2');
  var tier3El         = document.getElementById('ftb-tier-3');
  var addMoreBtn      = document.getElementById('ftb-add-more');
  var addMoreWrap     = document.getElementById('ftb-add-more-wrap');

  /* Tracks how many slots are currently visible — starts at REQUIRED (3) */
  var visibleSlots = REQUIRED;
  updateSlotsGridCols();

  /* ── Picker show-more toggle ──────────────────────────────────────────────── */
  if (showMoreBtn && pickerGrid) {
    showMoreBtn.addEventListener('click', function () {
      var extras = pickerGrid.querySelectorAll('[data-picker-extra]');
      pickerExpanded = !pickerExpanded;
      extras.forEach(function (el) {
        el.style.display = pickerExpanded ? '' : 'none';
      });
      showMoreBtn.textContent = pickerExpanded ? 'Show fewer products' : showMoreBtn.dataset.originalText || 'Show more products';
    });
    showMoreBtn.dataset.originalText = showMoreBtn.textContent;
  }

  /* ── Slot clicks ──────────────────────────────────────────────────────────── */
  slotsGrid.addEventListener('click', function (e) {
    var slotEl = e.target.closest('[data-slot]');
    if (!slotEl) return;
    if (e.target.closest('[data-remove-slot]')) return;
    activeSlot = parseInt(slotEl.dataset.slot, 10);
    openPicker();
  });

  slotsGrid.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var slotEl = e.target.closest('[data-slot]');
    if (slotEl) { activeSlot = parseInt(slotEl.dataset.slot, 10); openPicker(); }
  });

  /* ── Remove slot ──────────────────────────────────────────────────────────── */
  slotsGrid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-slot]');
    if (!btn) return;
    e.stopPropagation();
    clearSlot(parseInt(btn.dataset.removeSlot, 10));
  });

  /* ── Product selected from picker ─────────────────────────────────────────── */
  if (picker) {
    picker.addEventListener('click', function (e) {
      /* Don't trigger card selection when interacting with variant select */
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
      var productBtn = e.target.closest('[data-picker-product]');
      if (!productBtn) return;
      fillSlot(activeSlot, {
        productId: productBtn.dataset.productId,
        variantId: productBtn.dataset.variantId,
        title:     productBtn.dataset.productTitle,
        price:     parseInt(productBtn.dataset.productPrice, 10),
        image:     productBtn.dataset.productImage
      });
      closePicker();
    });

    /* Variant select change — update card's data attributes and displayed price */
    picker.addEventListener('change', function (e) {
      var sel = e.target.closest('.ftb-picker-variant-select');
      if (!sel) return;
      var btn = sel.closest('[data-picker-product]');
      if (!btn) return;
      var opt = sel.options[sel.selectedIndex];
      btn.dataset.variantId    = opt.value;
      btn.dataset.productPrice = opt.dataset.price || btn.dataset.productPrice;
      var priceEl = btn.querySelector('.ftb-picker-card-price');
      if (priceEl) priceEl.textContent = '£' + (parseInt(opt.dataset.price, 10) / 100).toFixed(2);
    });
  }

  if (pickerClose) pickerClose.addEventListener('click', closePicker);

  /* ── Add more products — reveals next batch of slots ─────────────────────── */
  if (addMoreBtn) {
    addMoreBtn.addEventListener('click', function () {
      var nextVisible = Math.min(visibleSlots + 2, maxProducts);
      for (var i = visibleSlots + 1; i <= nextVisible; i++) {
        var slotEl = slotsGrid.querySelector('[data-slot="' + i + '"]');
        if (slotEl) {
          slotEl.style.display = '';
          slotEl.removeAttribute('aria-hidden');
          slotEl.setAttribute('tabindex', '0');
        }
      }
      visibleSlots = nextVisible;
      updateSlotsGridCols();
      updateUI();
    });
  }

  /* ── Open / close picker ──────────────────────────────────────────────────── */
  function openPicker() {
    if (!picker) return;
    var hasChildren = picker.querySelector('[data-picker-product]');
    if (!hasChildren) return;
    picker.style.display = 'block';
    /* Simple overflow lock — avoids position:fixed jump on open/close */
    document.body.style.overflow = 'hidden';
  }

  function closePicker() {
    if (!picker) return;
    picker.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* Close picker when clicking the dark overlay (not the inner content box) */
  if (picker) {
    picker.addEventListener('click', function (e) {
      if (e.target === picker) closePicker();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && picker && picker.style.display !== 'none') closePicker();
  });

  /* ── Fill a slot ──────────────────────────────────────────────────────────── */
  function fillSlot(num, data) {
    if (!num) return;
    slots[num] = data;
    var slotEl = slotsGrid.querySelector('[data-slot="' + num + '"]');
    if (!slotEl) return;

    slotEl.classList.remove('is-empty', 'is-filling');
    slotEl.classList.add('is-filled');
    slotEl.setAttribute('aria-label', 'Slot ' + num + ' — ' + data.title);
    slotEl.innerHTML =
      '<img src="' + data.image + '" alt="' + esc(data.title) + '" style="width:100%;height:60%;object-fit:cover;">' +
      '<span class="ftb-slot__label" style="color:var(--ftb-acid);font-size:11px;padding:4px 8px;text-align:center;word-break:break-word;">' + esc(data.title) + '</span>' +
      '<button type="button" class="ftb-slot__remove" data-remove-slot="' + num + '" aria-label="Remove ' + esc(data.title) + '">✕</button>';

    /* Trigger CSS fill animation — force reflow to replay on re-fill */
    void slotEl.offsetWidth;
    slotEl.classList.add('is-filling');

    updateUI();
  }

  function clearSlot(num) {
    delete slots[num];
    var slotEl = slotsGrid.querySelector('[data-slot="' + num + '"]');
    if (slotEl) {
      slotEl.classList.remove('is-filled', 'is-filling');
      slotEl.classList.add('is-empty');
      slotEl.setAttribute('aria-label', 'Slot ' + num + ' — empty');
      slotEl.innerHTML = '<span class="ftb-slot__plus">+</span><span class="ftb-slot__label">Add Product</span>';
    }
    updateUI();
  }

  /* ── Slot grid column layout ─────────────────────────────────────────────── */
  function updateSlotsGridCols() {
    if (!slotsGrid) return;
    if (visibleSlots <= 3)      slotsGrid.dataset.cols = '3';
    else if (visibleSlots <= 5) slotsGrid.dataset.cols = '5';
    else                        slotsGrid.dataset.cols = '4'; /* 7 slots: 4 + 3 */
  }

  /* ── Silent slot clear (no updateUI call) — used for batch reset ─────────── */
  function clearSlotNoUI(num) {
    delete slots[num];
    var slotEl = slotsGrid.querySelector('[data-slot="' + num + '"]');
    if (!slotEl) return;
    slotEl.classList.remove('is-filled', 'is-filling');
    slotEl.classList.add('is-empty');
    slotEl.setAttribute('aria-label', 'Slot ' + num + ' — empty');
    slotEl.innerHTML = '<span class="ftb-slot__plus">+</span><span class="ftb-slot__label">Add Product</span>';
  }

  /* ── UI update ───────────────────────────────────────────────────────────── */
  function updateUI() {
    var count = Object.keys(slots).length;
    document.dispatchEvent(new CustomEvent('ftb:bundle-count', { detail: { count: count } }));

    /* ── Progress bar fill (caps at t3) ── */
    if (progressFillEl) {
      progressFillEl.style.width = Math.min(100, Math.round((count / t3) * 100)) + '%';
      var bar = progressFillEl.closest('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', Math.min(count, t3));
    }

    /* ── Milestone markers on bar ── */
    var marks = document.querySelectorAll('.ftb-bundle__prog-mark');
    marks.forEach(function (mark) {
      var n = parseInt(mark.dataset.mark, 10);
      var thresh = n === 1 ? t1 : (n === 2 ? t2 : t3);
      mark.classList.toggle('is-passed', count >= thresh);
    });

    /* ── Count label ── */
    var countWord = count === 1 ? 'product' : 'products';
    if (progressCountEl) progressCountEl.textContent = count + ' ' + countWord + ' selected';
    if (statusEl)        statusEl.textContent        = count + ' ' + countWord + ' selected';

    /* ── Tier milestone states ── */
    var tiers = [
      { el: tier1El, thresh: t1, prevThresh: 0 },
      { el: tier2El, thresh: t2, prevThresh: t1 },
      { el: tier3El, thresh: t3, prevThresh: t2 }
    ];
    tiers.forEach(function (tier) {
      if (!tier.el) return;
      var unlocked = count >= tier.thresh;
      var isNext   = !unlocked && count >= tier.prevThresh;
      tier.el.classList.remove('is-locked', 'is-next', 'is-unlocked');
      tier.el.classList.add(unlocked ? 'is-unlocked' : (isNext ? 'is-next' : 'is-locked'));
    });

    /* ── Next unlock message ── */
    if (unlockMsgEl) {
      var msg = '';
      if (count < t1) {
        var n1 = t1 - count;
        msg = 'Add ' + n1 + ' more to unlock your first free gift';
      } else if (count < t2) {
        var n2 = t2 - count;
        msg = 'Free Medusa unlocked ✓ — add ' + n2 + ' more to unlock 15% off';
      } else if (count < t3) {
        var n3 = t3 - count;
        msg = '15% off unlocked ✓ — add ' + n3 + ' more to unlock a free drying towel';
      } else {
        msg = 'Maximum rewards unlocked ✓';
      }
      unlockMsgEl.textContent = msg;
    }

    /* ── "Add more products" button ── */
    if (addMoreWrap) {
      var allFilled    = count > 0 && count === visibleSlots;
      var hasHidden    = visibleSlots < maxProducts;
      addMoreWrap.style.display = (allFilled && count >= REQUIRED && hasHidden) ? '' : 'none';
    }

    /* ── Pricing (visual — based on merchant-set discount %) ── */
    var fullTotal = Object.values(slots).reduce(function (s, v) { return s + v.price; }, 0);
    var kitTotal  = Math.round(fullTotal * (1 - discountPct / 100));
    var saving    = fullTotal - kitTotal;

    /* ── Kit total — real sum of selected prices, always shown when products selected ── */
    if (kitTotalEl) {
      if (count > 0 && fullTotal > 0) {
        kitTotalEl.style.display = '';
        if (kitTotalPriceEl) kitTotalPriceEl.textContent = fmt(fullTotal);
      } else {
        kitTotalEl.style.display = 'none';
      }
    }

    /* Only show kit price / saving when both the toggle and a discount code are set */
    if (pricingEl) {
      if (count > 0 && fullTotal > 0 && showVisualDiscount && discountCode) {
        pricingEl.style.display = '';
        if (fullPriceEl) fullPriceEl.textContent = fmt(fullTotal);
        if (kitPriceEl)  kitPriceEl.textContent  = fmt(kitTotal);
        if (savingEl)    savingEl.textContent     = 'Save ' + fmt(saving);
      } else {
        pricingEl.style.display = 'none';
      }
    }

    /* ── CTA button ── */
    if (bundleCta) {
      if (count >= REQUIRED) {
        bundleCta.disabled = false;
        bundleCta.textContent = ctaText;
      } else {
        bundleCta.disabled = true;
        bundleCta.textContent = 'ADD ' + (REQUIRED - count) + ' MORE TO UNLOCK';
      }
    }
  }

  /* ── Add kit to cart ──────────────────────────────────────────────────────── */
  if (bundleCta) {
    bundleCta.addEventListener('click', function () {
      var count = Object.keys(slots).length;
      if (count < REQUIRED || !window.FTBCart) return;

      bundleCta.disabled = true;
      bundleCta.textContent = 'Adding…';

      var selectedItems = Object.values(slots)
        .filter(function (item) { return item.variantId; })
        .map(function (item) {
          return {
            id:         parseInt(item.variantId, 10),
            quantity:   1,
            properties: { _bundle: 'ftb-kit' }
          };
        });

      if (selectedItems.length < REQUIRED) {
        bundleCta.disabled = false;
        bundleCta.textContent = ctaText;
        window.FTBCart.showToast('Please fill all slots before adding');
        return;
      }

      /* Fetch current cart first to prevent duplicate gift items */
      window.FTBCart.fetchCart()
        .then(function (currentCart) {
          var cartVariantIds = (currentCart.items || []).map(function (i) { return i.variant_id; });
          var itemsToAdd = selectedItems.slice(); /* copy */

          /* Tier 1 (3+ products): add Medusa 250ml gift */
          if (count >= t1 && gift1VariantId) {
            var g1id = parseInt(gift1VariantId, 10);
            if (cartVariantIds.indexOf(g1id) === -1) {
              itemsToAdd.push({
                id:         g1id,
                quantity:   1,
                properties: { _bundle_reward: 'Bundle Builder Gift', _reward_tier: 'Tier 1' }
              });
            }
          }

          /* Tier 3 (7+ products): also add Drying Towel gift */
          if (count >= t3 && gift2VariantId) {
            var g2id = parseInt(gift2VariantId, 10);
            if (cartVariantIds.indexOf(g2id) === -1) {
              itemsToAdd.push({
                id:         g2id,
                quantity:   1,
                properties: { _bundle_reward: 'Bundle Builder Gift', _reward_tier: 'Tier 3' }
              });
            }
          }

          /* Strip any items with missing/invalid variant IDs before sending */
          itemsToAdd = itemsToAdd.filter(function (item) {
            var valid = item.id && !isNaN(item.id) && item.id > 0;
            if (!valid) console.warn('[FTB Bundle] Skipped item with invalid variant ID:', item);
            return valid;
          });

          return fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ items: itemsToAdd })
          });
        })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (e) {
              throw new Error(e.description || e.message || 'Could not add to cart');
            });
          }
          return r.json();
        })
        .then(function () { return window.FTBCart.fetchCart(); })
        .then(function (cart) {
          window.FTBCart.onCartUpdate(cart);

          /* 5+ products: store discount code for checkout via cart drawer */
          if (count >= t2 && discountCode) {
            try { sessionStorage.setItem('ftb_kit_discount', discountCode); } catch (e) {}
            document.dispatchEvent(new CustomEvent('cart:kit-discount'));
          }

          /* Update and open cart drawer for all tiers */
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          document.dispatchEvent(new CustomEvent('cart:item-added'));

          var toastMsg = count >= t3
            ? 'Kit added! Free gifts included. Discount applied at checkout.'
            : count >= t2
              ? 'Kit added! Free Medusa included. 15% off applied at checkout.'
              : 'Kit added! Free Medusa included.';
          window.FTBCart.showToast(toastMsg);

          bundleCta.textContent = 'Added ✓';
          setTimeout(function () {
            Object.keys(slots).map(Number).forEach(function (n) { clearSlotNoUI(n); });
            for (var i = REQUIRED + 1; i <= maxProducts; i++) {
              var slotEl = slotsGrid.querySelector('[data-slot="' + i + '"]');
              if (slotEl) {
                slotEl.style.display = 'none';
                slotEl.setAttribute('aria-hidden', 'true');
                slotEl.setAttribute('tabindex', '-1');
              }
            }
            visibleSlots = REQUIRED;
            updateSlotsGridCols();
            updateUI();
          }, 1800);
        })
        .catch(function (err) {
          bundleCta.disabled = false;
          bundleCta.textContent = ctaText;
          window.FTBCart.showToast(err.message || 'Could not add kit — please try again');
        });
    });
  }

  /* ── Helpers ──────────────────────────────────────────────────────────────── */
  function fmt(pence) { return '£' + (pence / 100).toFixed(2); }
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
